const GrowthChartEmpty: React.FC<{ text: string }> = ({ text }) => {
    return (
        <div className="flex mt-8 items-center border border-darwin-accent-bright-yellow-800 space-x-10 py-6 px-8 w-full bg-darwin-accent-light-yellow rounded-8">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
            >
                <path
                    d="M7 13.625C4.66406 13.625 2.53125 12.4062 1.36328 10.375C0.195312 8.36914 0.195312 5.90625 1.36328 3.875C2.53125 1.86914 4.66406 0.625 7 0.625C9.31055 0.625 11.4434 1.86914 12.6113 3.875C13.7793 5.90625 13.7793 8.36914 12.6113 10.375C11.4434 12.4062 9.31055 13.625 7 13.625ZM7 3.875C6.64453 3.875 6.39062 4.1543 6.39062 4.48438V7.32812C6.39062 7.68359 6.64453 7.9375 7 7.9375C7.33008 7.9375 7.60938 7.68359 7.60938 7.32812V4.48438C7.60938 4.1543 7.33008 3.875 7 3.875ZM6.1875 9.5625C6.1875 10.0195 6.54297 10.375 7 10.375C7.43164 10.375 7.8125 10.0195 7.8125 9.5625C7.8125 9.13086 7.43164 8.75 7 8.75C6.54297 8.75 6.1875 9.13086 6.1875 9.5625Z"
                    fill="#8E6807"
                ></path>
            </svg>
            <span className="text-darwin-accent-dark-yellow text-12 font-700">{text}</span>
        </div>
    );
};

export default GrowthChartEmpty;
